(function () {
  'use strict';

  var root = document.querySelector('[data-gef-cd-bulk]');
  if (!root) return;

  var priceEl = root.querySelector('[data-bulk-price]');
  var pctEl = root.querySelector('[data-bulk-pct]');
  var inclEl = root.querySelector('[data-bulk-incl]');
  var saveEl = root.querySelector('[data-bulk-save]');
  var hIdx = root.querySelector('[data-bulk-hidden-idx]');
  var hUnit = root.querySelector('[data-bulk-hidden-unit]');
  var hBoxes = root.querySelector('[data-bulk-hidden-boxes]');
  var pdpRoot = root.closest('[data-pdp-root]');
  var qtyInput = pdpRoot ? pdpRoot.querySelector('.gef-cd-pdp__qty-input') : document.querySelector('.gef-cd-pdp__qty-input');
  var variantInput = pdpRoot ? pdpRoot.querySelector('[data-pdp-variant-id]') : document.querySelector('[data-pdp-variant-id]');
  var unitBox = pdpRoot ? pdpRoot.querySelector('[data-pdp-unit-box]') : document.querySelector('[data-pdp-unit-box]');
  var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-bulk-tier]'));
  var vatMultiplier = pdpRoot ? parseFloat(pdpRoot.getAttribute('data-pdp-vat-multiplier')) : 1.22;
  var bulkSource = root.getAttribute('data-bulk-source') || 'none';
  var variants = readVariants();
  var currentVariant = findCurrentVariant();

  if (!vatMultiplier || vatMultiplier < 1) vatMultiplier = 1.22;

  function fmt(n) {
    return (Number(n) || 0).toFixed(2).replace('.', ',');
  }

  function asNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function asInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function readVariants() {
    var node = pdpRoot ? pdpRoot.querySelector('[data-pdp-variants-json]') : document.querySelector('[data-pdp-variants-json]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function findCurrentVariant(id) {
    var currentId = id || (variantInput && variantInput.value);
    if (currentId) {
      var match = variants.find(function (variant) {
        return String(variant.id) === String(currentId);
      });
      if (match) return match;
    }
    return variants[0] || null;
  }

  function variantText(variant) {
    if (!variant) return '';
    return [
      variant.title,
      Array.isArray(variant.options) ? variant.options.join(' ') : '',
      variant.sku
    ].join(' ').toLowerCase();
  }

  function inferPackUnits(variant) {
    var text = variantText(variant);
    var match = text.match(/(\d{1,5})\s*(?:pz|pzi|pezzi|pcs)\b/i);
    if (match) return Math.max(asInt(match[1], 1), 1);

    var sku = variant && variant.sku ? String(variant.sku) : '';
    var skuMatch = sku.match(/[-_\s](\d{1,5})$/);
    if (skuMatch) return Math.max(asInt(skuMatch[1], 1), 1);

    return Math.max(asNumber(unitBox && unitBox.getAttribute('data-units-per-pack'), 1), 1);
  }

  function packWords(variant) {
    var text = variantText(variant);
    if (text.indexOf('cartone') !== -1 || text.indexOf('carton') !== -1) {
      return { one: 'cartone', many: 'cartoni', per: 'cartone' };
    }
    if (text.indexOf('busta') !== -1 || text.indexOf('sacchetto') !== -1) {
      return { one: 'busta', many: 'buste', per: 'busta' };
    }
    if (text.indexOf('scatola') !== -1) {
      return { one: 'scatola', many: 'scatole', per: 'scatola' };
    }
    if (text.indexOf('box') !== -1) {
      return { one: 'box', many: 'box', per: 'box' };
    }
    return { one: 'unita', many: 'unita', per: 'unita' };
  }

  function inferTierBoxes(tier, index) {
    if (!tier.getAttribute('data-base-boxes')) {
      var label = tier.querySelector('.gef-cd-bulk-tier__label');
      var text = label ? label.textContent : '';
      var match = text.match(/(\d+)\s*\+?\s*(?:unita|unità|box|cartoni?|buste?|scatole?|pz|pezzi)/i) || text.match(/^(\d+)/);
      var boxes = match ? asInt(match[1], 0) : asInt(tier.getAttribute('data-boxes'), 0);
      var defaults = [1, 2, 3, 5];
      if (!boxes || boxes < 1) boxes = defaults[index] || (index + 1);
      tier.setAttribute('data-base-boxes', String(boxes));
      tier.setAttribute('data-base-plus', text.indexOf('+') !== -1 ? '1' : '0');
      tier.setAttribute('data-base-unit', tier.getAttribute('data-unit') || '');
    }
    return Math.max(asInt(tier.getAttribute('data-base-boxes'), 1), 1);
  }

  function updateTierDom(tier, index, variant, baseExcl) {
    var boxes = inferTierBoxes(tier, index);
    var discount = Math.max(asInt(tier.getAttribute('data-discount'), 0), 0);
    var dynamicQikify = bulkSource === 'gef_qikify' || bulkSource === 'none';
    var originalUnit = asNumber(tier.getAttribute('data-base-unit') || tier.getAttribute('data-unit'), baseExcl);
    var unit = dynamicQikify ? baseExcl * (1 - (discount / 100)) : originalUnit;
    var words = packWords(variant);
    var packUnits = inferPackUnits(variant);
    var label = tier.querySelector('.gef-cd-bulk-tier__label');
    var labelRow = tier.querySelector('.gef-cd-bulk-tier__label-row');
    var qty = tier.querySelector('.gef-cd-bulk-tier__qty');
    var unitNode = tier.querySelector('.gef-cd-bulk-tier__unit');
    var totalNode = tier.querySelector('.gef-cd-bulk-tier__total');
    var subNode = tier.querySelector('.gef-cd-bulk-tier__total-sub');
    var plus = tier.getAttribute('data-base-plus') === '1';
    var labelText = boxes + (plus ? '+' : '') + ' ' + (boxes === 1 ? words.one : words.many);

    if (label) label.textContent = labelText;
    if (qty) qty.textContent = '(' + (packUnits * boxes) + ' pz)';
    if (labelRow) {
      var discountBadge = labelRow.querySelector('.gef-cd-bulk-tier__disc');
      if (discount > 0) {
        if (!discountBadge) {
          discountBadge = document.createElement('span');
          discountBadge.className = 'gef-cd-bulk-tier__disc';
          labelRow.appendChild(discountBadge);
        }
        discountBadge.textContent = 'Risparmi -' + discount + '%';
      } else if (discountBadge) {
        discountBadge.remove();
      }
    }

    tier.setAttribute('data-unit', String(unit));
    tier.setAttribute('data-boxes', String(boxes));
    tier.setAttribute('data-incl', String(unit * vatMultiplier));

    if (unitNode) {
      unitNode.textContent = '€' + fmt(unit) + '/' + words.per;
    }
    // FIX 2026-06-10 (owner): in rilievo il prezzo UNITARIO scontato (prima qui finiva il totale,
    // mentre la riga "totale" sotto restava statica al prezzo base di 1 unità)
    if (totalNode) totalNode.innerHTML = '€' + fmt(unit) + '<small style="font-size:.6em;font-weight:600;opacity:.6;margin-left:1px;">/' + words.per + '</small>';
    if (subNode) subNode.textContent = 'Totale €' + fmt(unit * boxes) + ' IVA escl.';
  }

  function selectedTier() {
    return root.querySelector('[data-bulk-tier].is-selected') || tiers[0] || null;
  }

  function setQuantity(value) {
    if (!qtyInput) return;
    var min = asInt(qtyInput.min, 1);
    var max = qtyInput.max ? asInt(qtyInput.max, null) : null;
    var next = Math.max(asInt(value, min), min);
    if (max) next = Math.min(next, max);
    if (String(qtyInput.value) === String(next)) return;
    qtyInput.value = String(next);
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function emitSelection(tier, options) {
    if (!tier) return;
    var opts = options || {};
    var unit = asNumber(tier.getAttribute('data-unit'), 0);
    var boxes = inferTierBoxes(tier, tiers.indexOf(tier));
    var discount = asInt(tier.getAttribute('data-discount'), 0);
    var incl = asNumber(tier.getAttribute('data-incl'), unit * vatMultiplier);
    var quote = tier.getAttribute('data-quote') === '1';
    var idx = tier.getAttribute('data-tier-index');

    tiers.forEach(function (item) {
      item.classList.toggle('is-selected', item === tier);
      var input = item.querySelector('input[type=radio]');
      if (input) input.checked = item === tier;
    });

    if (!quote && priceEl) priceEl.innerHTML = '&euro;' + fmt(unit);
    if (inclEl) inclEl.textContent = fmt(incl);
    if (pctEl) {
      if (discount > 0) {
        pctEl.hidden = false;
        pctEl.textContent = 'Prezzo volume';
      } else {
        pctEl.hidden = true;
      }
    }
    if (saveEl) saveEl.textContent = String(12 + discount);
    if (hIdx) hIdx.value = idx;
    if (hUnit) hUnit.value = unit;
    if (hBoxes) hBoxes.value = boxes;

    root.dispatchEvent(new CustomEvent('gef:bulk:change', {
      detail: { index: idx, unit: unit, boxes: boxes, discount: discount, quote: quote }
    }));

    if (opts.updateQuantity !== false && !quote) setQuantity(boxes);
  }

  function syncForVariant(variant, options) {
    var activeVariant = variant || currentVariant || findCurrentVariant();
    var grossPrice = activeVariant && activeVariant.price ? activeVariant.price / 100 : 0;
    var baseExcl = grossPrice ? grossPrice / vatMultiplier : asNumber(unitBox && unitBox.getAttribute('data-base-excl'), 0);
    var packUnits = inferPackUnits(activeVariant);

    if (unitBox) unitBox.setAttribute('data-units-per-pack', String(packUnits));

    tiers.forEach(function (tier, index) {
      updateTierDom(tier, index, activeVariant, baseExcl);
    });
    emitSelection(selectedTier(), options);
  }

  tiers.forEach(function (tier) {
    tier.addEventListener('click', function () {
      emitSelection(tier);
    });
  });

  window.addEventListener('gef:pdp:variant-change', function (event) {
    var detail = event.detail || {};
    currentVariant = findCurrentVariant(detail.id) || Object.assign({}, currentVariant || {}, detail);
    syncForVariant(currentVariant);
  });

  syncForVariant(currentVariant, { updateQuantity: false });
})();
